import React, { useState } from 'react';
import './App.css';
import CardCanvas from './components/CardCanvas';
import PictureGallery from './components/PictureGallery';
import TextEditor from './components/TextEditor';

function App() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [cardText, setCardText] = useState({
    //content: '小时候回外婆家过年，那是大别山深处的一个小村子，尽管山清水秀，但很穷。不过，春节前，村里家家都会做两样东西，一个是年糕，一个是腊肉。——《吃着吃着就老了》',
    color: '#ffffff',
    fontFamily: 'SourceHanSerif',
    writingMode: 'horizontal', // 默认水平书写模式
    textAlign: 'justify', // 默认两端对齐
    fontWeight: 'bold', // 默认粗体
    fontStyle: 'normal' // 默认正常样式
    // 移除 position 属性
    // position: { x: 85, y: 15 }
  });

  return (
    <div className="App">
      <header className="app-header">
        <h1>Picture Card Maker</h1>
      </header>

      <main className="app-main">
        <div className="editor-section">
          <div className="canvas-container">
            <CardCanvas
              selectedImage={selectedImage}
              cardText={cardText}
              setCardText={setCardText}
            />
          </div>

          <div className="controls-container">
            <TextEditor
              cardText={cardText}
              setCardText={setCardText}
            />
          </div>
        </div>

        <div className="gallery-section">
          <PictureGallery
            selectedImage={selectedImage}
            setSelectedImage={setSelectedImage}
          />
        </div>
      </main>

      <footer className="app-footer">
        <div className="footer-content">
          <p className="font-license">
            思源宋体 (Source Han Serif) 使用{' '}
            <a
              href="https://scripts.sil.org/OFL"
              target="_blank"
              rel="noopener noreferrer"
              className="license-link"
            >
              SIL开放字体许可证 1.1
            </a>
            {' '}授权
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;
